"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleResponse = void 0;
const responseError_1 = require("../errors/responseError");
const types_1 = require("../../types");
async function handleResponse(requestUrl, response) {
    // Use text() instead of json() as the error body might not be json data
    const body = await response.text();
    if (body.length === 0) {
        throw new responseError_1.ResponseError(204, 'Unexpected 204 response.', types_1.RequestErrorKind.NoContentException, '');
    }
    if (!response.ok) {
        const status = response.status;
        switch (status) {
            case 401:
                throw new responseError_1.ResponseError(response.status, 'Unauthorised request, likely due to an invalid API key.', types_1.RequestErrorKind.UnauthorisedRequestException, JSON.stringify(body));
                break;
            case 400:
                throw new responseError_1.ResponseError(response.status, 'Bad request, likely due to invalid parameters.', types_1.RequestErrorKind.BadRequestException, JSON.stringify(body));
                break;
            case 404:
                throw new responseError_1.ResponseError(response.status, `Request to ${requestUrl} gave 404 resource not found exception.`, types_1.RequestErrorKind.NotFoundException, JSON.stringify(body));
                break;
            case 429:
                throw new responseError_1.ResponseError(response.status, 'Rate limiting exception occurred.', types_1.RequestErrorKind.RateLimitedException, JSON.stringify(body));
                break;
            default:
                throw new responseError_1.ResponseError(response.status, `Non 2xx response status received.`, types_1.RequestErrorKind.UnknownException, JSON.stringify(body));
                break;
        }
    }
    return body;
}
exports.handleResponse = handleResponse;
